import React, {useState, useEffect} from "react";
import {Calendar} from "primereact/calendar";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {AutoComplete} from "primereact/autocomplete";
import {Button} from "primereact/button";
import axios from "axios";
import {base, locations_url, partners, projects_url} from "../../../api";

// fields that require fetching options
const FETCH_MAP = {
	project_name: {url: projects_url, label: "full_name_am"},
	partner_name: {url: partners, label: "full_name_am"},
};

export default function DisabledFormFields({
	item,
	disabled,
	inputValues,
	handleInputChange,
	handleRemoveInput,
	remove,
}) {
	const [options, setOptions] = useState([]); // full list
	const [suggestions, setSuggestions] = useState([]); // filtered for AutoComplete
	const [autoValue, setAutoValue] = useState(inputValues[item.field_name] || "");

	// fetch options if needed (including any field containing "location")
	useEffect(() => {
		let fetchInfo;
		if (item.field_name.includes("location")) {
			fetchInfo = {url: locations_url, label: "title_am"};
		} else {
			fetchInfo = FETCH_MAP[item.field_name];
		}
		if (fetchInfo) {
			axios.get(base + fetchInfo.url).then(res => {
				setOptions(res.data);
				// console.log(`Fetched ${item.field_name}:`, res.data);

				setSuggestions(res.data);
			});
		}
	}, [item.field_name]);

	// hide autogenerated or unspecified types
	if (!item.type || item.type === "autogenerated") {
		return null;
	}

	const value = inputValues[item.field_name] ?? "";

	const onChangeText = e => handleInputChange(item.field_name, e.target.value);

	const onChangeNumber = e => handleInputChange(item.field_name, e.value);

	const onChangeCalendar = e => handleInputChange(item.field_name, e.value);

	// filter by both label field and title_en
	const filterSuggestions = event => {
		const q = event.query.toLowerCase();
		// determine which field to search
		let fetchInfo = item.field_name.includes("location")
			? {label: "title_am"}
			: FETCH_MAP[item.field_name];
		const labelKey = fetchInfo?.label;
		const englishKey =
			labelKey && labelKey.endsWith("_am")
				? labelKey.replace(/_am$/, "_en")
				: labelKey === "full_name_am"
				? "full_name_en"
				: "title_en";
		setSuggestions(
			options.filter(opt => {
				const primary = String(opt[labelKey] || "").toLowerCase();
				const secondary = String(opt[englishKey] || "").toLowerCase();
				const legalFullNameAm = String(opt["legal_full_name_am"] || "").toLowerCase();
				const legalFullNameEn = String(opt["legal_full_name_en"] || "").toLowerCase();
				const legalHeadAm = String(opt["legal_head_am"] || "").toLowerCase();
				const legalHeadEn = String(opt["legal_head_en"] || "").toLowerCase();
				const fullNameAm = String(opt["full_name_am"] || "").toLowerCase();
				const fullNameEn = String(opt["full_name_en"] || "").toLowerCase();
				return (
					primary.includes(q) ||
					secondary.includes(q) ||
					legalFullNameAm.includes(q) ||
					legalFullNameEn.includes(q) ||
					legalHeadAm.includes(q) ||
					legalHeadEn.includes(q) ||
					fullNameAm.includes(q) ||
					fullNameEn.includes(q)
				);
			}),
		);
	};

	const onSelectAuto = e => {
		setAutoValue(e.value);
		handleInputChange(item.field_name, e.value);
	};

	const itemTemplate = opt => {
		const isLocation = item.field_name.includes("location");
		const labelKey = isLocation ? "title_am" : FETCH_MAP[item.field_name]?.label;
		const englishKey =
			labelKey && labelKey.endsWith("_am") ? labelKey.replace(/_am$/, "_en") : "title_en";
		return (
			<div className="p-2" style={{borderBottom: "1px solid #eee", width: "300px"}}>
				<div>{opt[labelKey]}</div>
				<div className="small opacity-75">{opt[englishKey]}</div>
			</div>
		);
	};
	// console.log(suggestions);
	// console.log(item);

	return (
		<div key={item.field_name} className="col-6 d-flex align-items-center">
			<div className="col-11 mb-2">
				<label className="ps-2 mb-2" htmlFor={item.field_name}>
					{item.description}
				</label>

				{item.type === "calendar" && (
					<Calendar
						disabled={disabled}
						id={item.field_name}
						value={value || null}
						onChange={onChangeCalendar}
						showIcon
						className="w-100 p-0"
					/>
				)}

				{item.type === "number_input" && (
					<InputNumber
						disabled={disabled}
						id={item.field_name}
						value={value || 0}
						onValueChange={onChangeNumber}
						className="w-100 p-0"
					/>
				)}

				{(item.type === "dropdown" || item.type === "autocomplete") && (
					<AutoComplete
						disabled={disabled}
						id={item.field_name}
						value={autoValue}
						suggestions={suggestions}
						itemTemplate={itemTemplate}
						completeMethod={filterSuggestions}
						field={
							item.field_name.includes("location") ? "title_am" : FETCH_MAP[item.field_name]?.label
						}
						onChange={onSelectAuto}
						dropdown
						placeholder="Select..."
						className="w-100 p-0"
					/>
				)}

				{item.type === "text_input" && (
					<InputText
						disabled={disabled}
						id={item.field_name}
						value={value}
						onChange={onChangeText}
						className="w-100"
					/>
				)}
			</div>

			{remove && (
				<Button
					icon="pi pi-trash"
					text
					rounded
					severity="danger"
					className="col-1 mt-3"
					onClick={() => handleRemoveInput(item)}
				/>
			)}
		</div>
	);
}
